/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, createUrlTreeFromSnapshot } from '@angular/router';
import { clusterById, clusterManagementTeams } from '@app/core/ngrx';
import { AppState } from '@app/core/types';
import { isClusterPersonal } from '@app/domain/teams';
import { Store } from '@ngrx/store';
import { ClusterStatus } from '@shared/types/cluster';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CanShareClusterGuard {
  constructor(private store: Store<AppState>) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | UrlTree | boolean {
    const { contextActionClusterId } = route.params;
    return combineLatest([
      this.store.select(clusterById(contextActionClusterId)),
      this.store.select(clusterManagementTeams),
    ]).pipe(
      map(
        ([cluster, teams]) =>
          !(
            !cluster ||
            !teams ||
            !isClusterPersonal(teams, cluster) ||
            cluster.status === ClusterStatus.PROVISIONING
          ) || createUrlTreeFromSnapshot(route, ['..']),
      ),
    );
  }
}
